import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompletedOrdersAction } from '../../store/actions/orders';
import TradeCards from './TradeCard';
import OrderDetailsDialog from '../Common/OrderDetailsDialog';
import { getOrderDetailFields } from '../../utils/orderDetailsConfig';
import GenericTable from '../Common/GenericTable';
import { completedOrdersConfig } from '../../config/tableConfigs';
import CommonMessages from '../Common/NoDataMessages';
import NoOrdersIllustration from '../Common/NoOrdersIllustration';

const Completed = () => {
  const completed = useSelector((state) => state.orders.arrCompletedData);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    dispatch(fetchCompletedOrdersAction())
  }, []);

  useEffect(() => {
    setCompletedOrders(completed);
    setLoading(false);
  }, [completed]);

  const formatTime = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const handleRowClick = (order) => {
    setSelectedOrder(order);
  };

  const handleCloseDetails = () => {
    setSelectedOrder(null);
  };

  return (
    <>
      {/* <Box sx={{ width: '100%' }}> */}
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            p: 3,
            backgroundColor: theme.palette.background.default
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : error ? (
        <Box
          sx={{
            p: 3,
            textAlign: 'center',
            color: theme.palette.error.main,
            backgroundColor: theme.palette.background.default
          }}
        >
          <Typography>{error}</Typography>
        </Box>
      ) : completedOrders.length === 0 ? (
        <CommonMessages
          icon={<NoOrdersIllustration />}
          messageHead="No completed orders"
          messageBody="You have not completed any orders yet"
        />
      ) : isMobile ? (
        // Show card-based design on mobile
        <TradeCards trades={completedOrders} tab="COMPLETE" />
      ) : (
        <GenericTable
          data={completedOrders}
          config={completedOrdersConfig(isMobile)}
          onRowClick={handleRowClick}
          isMobile={isMobile}
        />
      )}

      {selectedOrder && (
        <OrderDetailsDialog
          order={selectedOrder}
          onClose={handleCloseDetails}
          isMobile={isMobile}
          detailFields={getOrderDetailFields(selectedOrder, formatTime, 'COMPLETED')}
          formatTime={formatTime}
          showRepeatButton={true}
        />
      )}
    </>
    // </Box>

  );
};

export default Completed; 